import { render } from "./Studydata.vue?vue&type=template&id=15cb46a0&scoped=true"
import script from "./Studydata.vue?vue&type=script&lang=js"
export * from "./Studydata.vue?vue&type=script&lang=js"

import "./Studydata.vue?vue&type=style&index=0&id=15cb46a0&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cb46a0"]])

export default __exports__